import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../../v2SPRINTA/style.css'

import Display from '../../../v2SPRINTA/atoms/Display'
import { Col, Row, Container } from '../../../v2SPRINTA/atoms/Grid'
import FontIcon from '../../../SPRINTA/atoms/FontIcon'

class ExperienceOk extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <Container>
                <Row justifyContent='center' style={{ paddingTop: '60px', paddingBottom: '60px' }}>
                    <Col size='12 12 10 8' text='center' style={{ marginBottom: '30px' }}>
                        <Display size={2}>
                            Obrigado! Sua experiência foi <b> enviada para análise</b>
                        </Display>
                        <br />
                        <span>
                        Agora é conosco. Iremos analisar todos os dados da sua experiência e, se aprovarmos,
                        você irá receber um e-mail com os próximos passos:
                        </span>
                    </Col>

                    <Col size='10 10 8 6'>
                        <Row style={{ marginBottom: '30px' }}>
                            <Col text='center' size='2'><FontIcon name='admin_calendar' size={48} color='#f50' /></Col>
                            <Col size='10'>
                                <Display size={3}>
                                    Defina as datas e horários da sua experiência
                                </Display>
                                <br />
                                Caso necessário, você poderá definir datas e horários diferentes para que sua experiência ocorra, abrangendo diversos públicos.
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: '30px' }}>
                            <Col text='center' size='2'><FontIcon name='sprinta-list' size={48} color='#f50' /></Col>
                            <Col size='10'>
                                <Display size={3}>
                                Defina o número de vagas
                                </Display>
                                <br />
                                Organização é importante, não? Então você precisará nos informar a quantidade de vagas da sua experiência.
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: '30px' }}>
                            <Col text='center' size='2'><FontIcon name='admin_notification' size={48} color='#f50' /></Col>
                            <Col size='10'>
                                <Display size={3}>
                                Publique
                                </Display>
                                <br />
                                Publique sua experiência no SPRINTA para mais de 300 mil atletas.
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: '30px' }}>
                            <Col text='center' size='2'><FontIcon name='balance' size={48} color='#f50' /></Col>
                            <Col size='10'>
                                <Display size={3}>
                                Operacional
                                </Display>
                                <br />
                                Quanto sua experiência for aprovada, cobraremos uma taxa de 20% sobre as vendas para custos de marketing, impostos e plataforma.
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        )
    }
}

const mapStateToProps = store => ({
    user: store.user
})
const mapDispatchToProps = {
}
export default connect( mapStateToProps, mapDispatchToProps )(ExperienceOk)


// WEBPACK FOOTER //
// ./src/App/pages/ExperienceOk/index.js